import { useContext } from 'react';
import { GeolocationContext } from './GeolocationProvider';
const useGeolocation = () => {
    const context = useContext(GeolocationContext);
    if (context === undefined) {
        throw new Error('useGeolocation must be used within a GeolocationProvider');
    }
    return context;
};
export default useGeolocation;
